
import { Vue , Component } from 'vue-property-decorator';
@Component({
  name: 'Layout',
  components: { },
})
export default class extends Vue {


}
